import React from 'react';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

// Matches getHeaderColor in Norms.js (0-based data-column index, excl. label col)
const headerArgb = (dataColIdx) => {
  if (dataColIdx < 5) return 'FFC00000'; // red
  if (dataColIdx < 7) return 'FFFFC000'; // yellow
  return 'FF92D050';                      // green
};

const border = {
  top:    { style: 'thin', color: { argb: 'FFD1D5DB' } },
  left:   { style: 'thin', color: { argb: 'FFD1D5DB' } },
  bottom: { style: 'thin', color: { argb: 'FFD1D5DB' } },
  right:  { style: 'thin', color: { argb: 'FFD1D5DB' } },
};

const ExportButton = () => {
  const exportToExcel = async () => {
    const table = document.getElementById('normsTable');
    if (!table) { alert('Table not found!'); return; }

    const allRows = Array.from(table.querySelectorAll('tr'));
    const totalRows = allRows.length;
    const FOOTER_COUNT = 3; // Overall Mean, Samples Considered, Number of Products

    const wb = new ExcelJS.Workbook();
    wb.creator = '4Sight Norms';
    const ws = wb.addWorksheet('Norms');

    allRows.forEach((tr, ri) => {
      const cells = Array.from(tr.querySelectorAll('th, td'));
      const wsRow = ws.getRow(ri + 1);
      wsRow.height = 22;

      const isHeader = ri === 0;
      const isFooter = ri >= totalRows - FOOTER_COUNT;

      cells.forEach((cell, ci) => {
        const raw = cell.innerText.trim();
        const num = parseFloat(raw.replace(/,/g, ''));
        const wsCell = wsRow.getCell(ci + 1);

        wsCell.value = (!isNaN(num) && raw !== '') ? num : raw;
        wsCell.border = border;

        if (isHeader) {
          if (ci === 0) {
            // "Percentile" label cell
            wsCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1E293B' } };
            wsCell.font  = { name: 'Calibri', size: 11, bold: true, color: { argb: 'FFFFFFFF' } };
          } else {
            wsCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: headerArgb(ci - 1) } };
            wsCell.font  = { name: 'Calibri', size: 11, bold: true, color: { argb: 'FFFFFFFF' } };
          }
          wsCell.alignment = { horizontal: ci === 0 ? 'left' : 'center', vertical: 'middle', wrapText: false };

        } else if (isFooter) {
          wsCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF1F5F9' } };
          wsCell.font  = { name: 'Calibri', size: 11, bold: true, color: { argb: 'FF0F172A' } };
          wsCell.alignment = { horizontal: ci === 0 ? 'left' : 'center', vertical: 'middle' };

        } else {
          // Alternating data rows
          wsCell.fill = {
            type: 'pattern', pattern: 'solid',
            fgColor: { argb: ri % 2 === 0 ? 'FFFFFFFF' : 'FFF8FAFC' },
          };
          wsCell.font = {
            name: 'Calibri', size: 11,
            bold: ci === 0,
            color: { argb: ci === 0 ? 'FF334155' : 'FF475569' },
          };
          wsCell.alignment = { horizontal: ci === 0 ? 'left' : 'center', vertical: 'middle' };
        }
      });

      wsRow.commit();
    });

    // Auto column widths
    ws.columns.forEach((col) => {
      let maxLen = 8;
      col.eachCell({ includeEmpty: false }, (c) => {
        const len = c.value != null ? String(c.value).length : 0;
        if (len > maxLen) maxLen = len;
      });
      col.width = Math.min(maxLen + 3, 32);
    });

    // Freeze header row
    ws.views = [{ state: 'frozen', ySplit: 1 }];

    const buf = await wb.xlsx.writeBuffer();
    saveAs(
      new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
      'NormsTable.xlsx'
    );
  };

  return (
    <button
      onClick={exportToExcel}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 6,
        background: '#16a34a', color: '#fff', border: 'none',
        borderRadius: 8, padding: '8px 16px', fontSize: 13,
        fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit',
        marginBottom: 12,
      }}
    >
      ↓ Export to Excel
    </button>
  );
};

export default ExportButton;
